import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white p-6 md:p-10">
      <div className="">

        <div className="mt-6 md:mt-0 text-right">
          <h3 className="text-lg font-bold mb-3">Get in Touch</h3>
          <div>
            <div className='font-semibold '>Sydney</div>
            <a href="tel:1300850275">1300 850 275</a><span className='px-2 text-gray-500'>|</span>
            <a
              href="https://www.google.com/maps?q=137+Turrella+St,+Turrella+NSW+2205"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >137 Turrella Street, Turrella NSW 2205</a>
          </div>

          <div>
            <div className='font-semibold mt-2'>Melbourne</div>
            <a href="tel:1300850275">1300 850 275</a><span className='px-2 text-gray-500'>|</span>
            <a
              href="https://www.google.com/maps?q=78-86+Western+Ave,+Westmeadows+VIC+3049"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >78-86 Western Avu, Westmeadows VIC 3049</a>
          </div>

          <div>
            <div className='font-semibold mt-2'>Interlnational</div>
            <a href="tel:+61280144448">+61 2 8014 4448</a>
          </div>

          <button className="mt-8 bg-primary hover:bg-primary/80 text-white font-semibold px-5 py-2 rounded-lg">
            <a href="mailto:drivelinerental@gmail.com" >Email Us</a>
          </button>
        </div>
      </div>

    </footer>
  );
}

export default Footer;